import { openNotificationWithIcon } from "client/utils";
import { SubscriptionPhaseLevel } from "common/types/subscription";

/**
 * Download Guard Utility
 *
 * Provides centralized download restriction checking for Compliance_Archive phase.
 * When phaseLevel is 3/4, all downloads should be blocked.
 *
 * Usage:
 * 1. SubscriptionProvider calls setDownloadGuardPhaseLevel() when phaseLevel changes
 * 2. Download functions call isDownloadRestricted() to check if blocked
 * 3. If blocked, call showDownloadRestrictedNotification() and return early
 */

let currentPhaseLevel = 0;

/**
 * Sets the current phase level. Called by SubscriptionProvider when phaseLevel changes.
 */
export function setDownloadGuardPhaseLevel(level: number): void {
  currentPhaseLevel = level;
}

/**
 * Checks if downloads are restricted.
 */
export function isDownloadRestricted(): boolean {
  return currentPhaseLevel >= SubscriptionPhaseLevel.Soft_Enforcement;
}

/**
 * Shows a notification informing the user that downloads are restricted.
 */
export function showDownloadRestrictedNotification(): void {
  openNotificationWithIcon(
    "error",
    "Download Restricted",
    "The download functionality is currently restricted due to an overdue payment. Please contact your administrator to renew the subscription and restore access."
  );
}
